import { render } from "./NewAttributeMaster.vue?vue&type=template&id=93ccc78c"
import script from "./NewAttributeMaster.vue?vue&type=script&lang=js"
export * from "./NewAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__